import { nonAuthApi } from './apiHelper';

export const postLogin = (username, password) => nonAuthApi.post('/auth/login', { username, password });
